import { render, staticRenderFns } from "./LandPageAbout.vue?vue&type=template&id=044f91a6&scoped=true&"
import script from "./LandPageAbout.vue?vue&type=script&lang=js&"
export * from "./LandPageAbout.vue?vue&type=script&lang=js&"
import style0 from "./LandPageAbout.vue?vue&type=style&index=0&id=044f91a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f91a6",
  null
  
)

export default component.exports